import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'
import { CSSProperties } from 'react'

export const BOTTOM_SHEET_RIGHT_OFFSET = '100px' satisfies CSSProperties['right']

export const CloseButtonWrapper = styled.div`
  position: absolute;
  top: ${Spacing.S16};
  right: ${Spacing.S12};
`

export type TourStepMetaStyle = Partial<
  Pick<
    CSSProperties,
    | 'bottom'
    | 'backgroundColor'
    | 'border'
    | 'borderBottom'
    | 'borderLeft'
    | 'borderRight'
    | 'borderTop'
    | 'borderRadius'
    | 'display'
    | 'height'
    | 'padding'
  >
>

export const TourStepWrapper = styled.div<TourStepMetaStyle>`
  ${({ backgroundColor }) => `background-color: ${backgroundColor ?? Color.White}`};
  bottom: ${({ bottom }) => bottom ?? Spacing.S12};
  ${({ border }) => (border !== undefined ? `border: ${border}` : undefined)};
  ${({ borderBottom }) => (borderBottom !== undefined ? `border-bottom: ${borderBottom}` : undefined)};
  ${({ borderLeft }) => (borderLeft !== undefined ? `border-left: ${borderLeft}` : undefined)};
  ${({ borderRight }) => (borderRight !== undefined ? `border-right: ${borderRight}` : undefined)};
  ${({ borderTop }) => (borderTop !== undefined ? `border-top: ${borderTop}` : undefined)};
  ${({ borderRadius }) => (borderRadius !== undefined ? `border-radius: ${borderRadius}` : undefined)};
  ${({ display }) => (display !== undefined ? `display: ${display}` : undefined)};
  ${({ height }) => (height !== undefined ? `height: ${height}` : undefined)};
  overflow: hidden;
  ${({ padding }) => (padding !== undefined ? `padding: ${padding}` : undefined)};
  /* stylelint-disable-next-line order/properties-order -- width after dynamic padding interpolation */
  width: 413px;
  position: fixed;
  right: ${BOTTOM_SHEET_RIGHT_OFFSET};
  z-index: 1;
  transition-duration: 0.5s;
  transition-property: height, width, background-color;
  transition-timing-function: ease-in-out;
`
